import { cloneDeep } from "lodash";
import { eurofileActions as actions } from "../actions";
import { initialState } from "../initialState";
import { createReducer, methodSwitcher } from "./utilities";

const { meeting } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setEurofileList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentEurofile = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionEurofile = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const eurofileReducer = createReducer(meeting, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setEurofileList,
  [actions.CURRENT]: setCurrentEurofile,
  [actions.CUD]: actionEurofile,
});
